<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" append-to-body width="1200px" :custom-class="$style.dialog"
    :modal-class="$style.modal" @opened="onSearchDialogOpen">
    <h2 :class="$style.dialog__title">搜索
      <nuxt-link :class="$style.dialog__map" to="/cruise-map" target="_blank">
        <i class="ficon ficon-ditu mr-1"></i>
        <span>地图找船</span>
      </nuxt-link>
    </h2>
    <div class="flex items-center mt-8">
      <form class="w-[720px]" @submit.prevent="onSearch">
        <input ref="focusableElement" v-model="keyword" :class="$style.search__input" type="text"
          placeholder="邮轮品牌/邮轮名称/邮轮资讯/热门原创" />
      </form>
    </div>
    <div :class="$style.hotSearch">
      <span :class="$style.hotSearch__label"># 热门搜索 #</span>
      <nuxt-link v-for="(tag, index) in hot_keywords" :key="index" :class="$style.hotSearch__tag" :to="tag.to">{{
          tag.title
      }}</nuxt-link>
    </div>
  </el-dialog>
</template>
<script>
import { useRouter, nextTick } from "@nuxtjs/composition-api";
import useCompanySearch from "~/composables/useCompanySearch";

export default {
  setup(props, { emit }) {
    const { hot_keywords, keyword, focusableElement } = useCompanySearch();
    const router = useRouter();
    function onSearch() {
      router.push({
        path: "/company/search",
        query: {
          q: keyword.value,
        },
      });

      emit('update:visible', false)
    }

    async function onSearchDialogOpen() {
      nextTick(() => {
        console.log(focusableElement.value);
        focusableElement.value.focus();
      });
    }

    return {
      hot_keywords,
      focusableElement,
      keyword,
      onSearch,
      onSearchDialogOpen,
    };
  },
};
</script>
<style lang="scss" module>
.modal {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  opacity: 0.98;
}
.dialog {
  background-color: transparent;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  -webkit-box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
}
.dialog :global .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: $secondary-text-color;
}
.dialog__title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  -webkit-align-items: baseline;
  align-items: baseline;
  font-weight: 600;
  font-size: 3.75rem;
  line-height: 1;
  line-height: 5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  vertical-align: baseline;
}
.dialog__map {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-size: 26px;
  line-height: 1;
  margin-left: 25px;
  --tw-text-opacity: 1;
  color: rgba(98, 103, 109, var(--tw-text-opacity));
}
.dialog__map span {
  font-weight: 500;
}
.search__input {
  background-color: transparent;
  font-size: 40px;
  line-height: 1;
  padding-right: 1.25rem;
  width: 100%;
}
.hotSearch {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  margin-top: 2.75rem;
}
.hotSearch__label {
  font-weight: 600;
  font-size: 1.625rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.hotSearch__tag {
  --tw-bg-opacity: 1;
  background-color: rgba(182, 187, 200, var(--tw-bg-opacity));
  border-radius: 0.375rem;
  display: inline-block;
  margin-left: 2rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
</style>
